import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Args, Flags } from '@oclif/core';
import { Queue } from '@switchboard-xyz/on-demand';

export default class QueueConfigure extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Configure a queue account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    authority: Flags.string({
      description: 'new authority for the queue account',
      required: false,
    }),
    reward: Flags.integer({
      description: 'new reward for the queue account',
      required: false,
    }),
    nodeTimeout: Flags.integer({
      description: 'timeout before oracles can be removed from queue',
      required: false,
    }),
  };

  static args = {
    queue: Args.string({
      description: 'The queue account to configure',
    }),
  };

  async run() {
    const { args, flags } = await this.parse(
      this.constructor as typeof QueueConfigure
    );

    const program = await this.program;

    const queue = new Queue(program, new web3.PublicKey(args.queue!));
    const ix = await queue.setConfigsIx({
      authority: flags.authority
        ? new web3.PublicKey(flags.authority)
        : undefined,
      reward: flags.reward ?? undefined,
      nodeTimeout: flags.nodeTimeout ?? undefined,
    });

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to configure queue account');
  }
}
